{
  "collectionLabel": "Pasiūlymai"
}
